const actions = {
  // APP CONFIG ACTIONS
  LIST_APP_CONFIGS_BEGIN: 'LIST_APP_CONFIGS_BEGIN',
  LIST_APP_CONFIGS_SUCCESS: 'LIST_APP_CONFIGS_SUCCESS',
  LIST_APP_CONFIGS_ERR: 'LIST_APP_CONFIGS_ERR',

  UPDATE_APP_CONFIG_BEGIN: 'UPDATE_APP_CONFIG_BEGIN',
  UPDATE_APP_CONFIG_SUCCESS: 'UPDATE_APP_CONFIG_SUCCESS',
  UPDATE_APP_CONFIG_ERR: 'UPDATE_APP_CONFIG_ERR',

  ENABLE_APP_BEGIN: 'ENABLE_APP_BEGIN',
  ENABLE_APP_SUCCESS: 'ENABLE_APP_SUCCESS',
  ENABLE_APP_ERR: 'ENABLE_APP_ERR',

  DISABLE_APP_BEGIN: 'DISABLE_APP_BEGIN',
  DISABLE_APP_SUCCESS: 'DISABLE_APP_SUCCESS',
  DISABLE_APP_ERR: 'DISABLE_APP_ERR',

  listAppConfigsBegin: () => {
    return {
      type: actions.LIST_APP_CONFIGS_BEGIN,
    };
  },

  listAppConfigsSuccess: (data) => {
    return {
      type: actions.LIST_APP_CONFIGS_SUCCESS,
      data,
    };
  },

  listAppConfigsErr: (err) => {
    return {
      type: actions.LIST_APP_CONFIGS_ERR,
      err,
    };
  },

  updateAppConfigBegin: () => {
    return {
      type: actions.UPDATE_APP_CONFIG_BEGIN,
    };
  },

  updateAppConfigSuccess: (data) => {
    return {
      type: actions.UPDATE_APP_CONFIG_SUCCESS,
      data,
    };
  },

  updateAppConfigErr: (err) => {
    return {
      type: actions.UPDATE_APP_CONFIG_ERR,
      err,
    };
  },

  enableAppBegin: () => {
    return {
      type: actions.ENABLE_APP_BEGIN,
    };
  },

  enableAppSuccess: (data) => {
    return {
      type: actions.ENABLE_APP_SUCCESS,
      data,
    };
  },

  enableAppErr: (err) => {
    return {
      type: actions.ENABLE_APP_ERR,
      err,
    };
  },

  disableAppBegin: () => {
    return {
      type: actions.DISABLE_APP_BEGIN,
    };
  },

  disableAppSuccess: (data) => {
    return {
      type: actions.DISABLE_APP_SUCCESS,
      data,
    };
  },

  disableAppErr: (err) => {
    return {
      type: actions.DISABLE_APP_ERR,
      err,
    };
  },
};

export default actions;
